<div class="progress-dialog">
  <p>
    {{message}}
  </p>
  <mat-progress-bar mode="indeterminate">
  </mat-progress-bar>
</div>
